module.exports = __webpack_public_path__ + "img/avatar.897dcacc.svg";